<template>
    <div class="dingdan">
<!--        <breadcrumb :routerList="[{to:'/dingd/secondDingdmainlist',title:'订单管理'},{title:'订单列表(二级经销商)'}]" v-if="firstPageFlag!=1"/>-->
      <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
                            <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                        </el-form-item>
                        <el-form-item label="　创建人编码/名称" prop="cuserCodeNameLike">
                            <el-input v-model="formInline.cuserCodeNameLike" placeholder="请输入"
                                    style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="　订单类型" prop="orderCategory1">
                            <el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
                                <el-option v-for="item in orderCategory1List"
                                        :key="item.code"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </div>

                    <el-collapse-transition>
                        <div v-show="isScreen">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="自产 /OEM" prop="prodtype">
                                    <el-select v-model="formInline.prodtype" :clearable="true"
                                            placeholder="请选择">
                                        <el-option label="自产" value="自产"></el-option>
                                        <el-option label="OEM" value="OEM"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="　售达方编码/名称" prop="sdfCodeNameLike">
                                    <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"
                                            style="width: 100%"></el-input>
                                </el-form-item>
                                <el-form-item label="订单状态" prop="status">
                                    <brselect clearable category="order_status" :v="formInline.status"
                                            v-model="formInline.status"></brselect>
                                </el-form-item>


                                <el-form-item label="销售组织" prop="saleGroupCode">
                                    <brselect category="xiaoshou_zuzhi" :v="formInline.saleGroupCode" :showcode="true"
                                            v-model="formInline.saleGroupCode" clearable></brselect>
                                </el-form-item>
                            </div>
                            <div class="h-thirdColumn w-newColumn">

                                <el-form-item label="创建时间" prop="cdatebegin" style="width: 50%;">
                                    <el-date-picker
                                        v-model="formInline.cdatebegin"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                    <span class="w-time-to">至</span>
                                    <el-date-picker
                                        v-model="formInline.cdateend"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item label="　产品编码/名称" prop="materialCodeNameLike">
                                    <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
                                </el-form-item>


                            </div>
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="　一级经销商订单号" prop="firstSapCode"  style="width: 50%;">
                                    <el-input v-model="formInline.firstSapCode" placeholder="请输入"  ></el-input>
                                </el-form-item>
                                <el-form-item label="一级经销商编码/名称" prop="firstLevelAgentLike">
                                    <el-input v-model="formInline.firstLevelAgentLike" placeholder="请输入"
                                              style="width: 100%"></el-input>
                                </el-form-item>

                                <el-form-item label="发货方式" prop="secondAgentFhWay">
                                    <el-select v-model="formInline.secondAgentFhWay" clearable placeholder="请选择" style="width:100%">
                                        <el-option v-for="item in secondAgentFhWayList"
                                                   :key="item.code"
                                                   :label="item.name"
                                                   :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                        </div>
                    </el-collapse-transition>

                </el-form>
                <div class="l-screenBox">
                    <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                    </div>
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                @click="imgfalse3" v-if="firstPageFlag!=1">
                            新建订单
                        </el-button>

                    </div>
                </div>
            </div>
        </div>
        <div class="h-mrt30 margin">
<!--            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">每月的最后一天中午12点至次日凌晨4点为系统禁止签收时间，不可进行签收操作！</h6>-->
          <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">注：一级商满足发货条件时点发货按钮，售后网点接单提货</h6>
        </div>
        <div class="h-table h-mrt30 tableclslist">

            <el-table
                    ref="ddtable"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    @selection-change="handleSelectionChange"
                    stripe
                    border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
                    max-height="450"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        type="index"
                        width="40"
                        label="#"
                        fixed
                >
                </el-table-column>
                <el-table-column
                fixed
                        prop="sapCode"
                        label="订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="售达方名称"
                        fixed
                        :show-overflow-tooltip="true"
                        width="180">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.soldToName}}
                            </div>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        label="产品名称"
                        fixed
                        :show-overflow-tooltip="true"
                        width="140">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.materialName}}
                            </div>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="数量"
                        width="60">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.proNumber}}
                                </div>
                            </template>
                </el-table-column>
              <el-table-column
                  prop="installNumber"
                  label="安装数量"
                  width="80">
                <template scope="scope">
                  <div style="text-align: center; color: #0e77e8;" class="handHover">
                    <a @click="clickInstallNumber(scope.row)">{{scope.row.installNumber}}</a>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="installStatus"
                  label="安装状态"
                  width="80">
                <template scope="scope">
                  <div>
                    {{scope.row.installStatus}}
                  </div>
                </template>
              </el-table-column>
                <el-table-column
                    prop="note1"
                    label="备注"
                    :show-overflow-tooltip="true"
                    min-width="180">
                    <template scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.note1}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="secondAgentFhWay"
                    label="发货方式"
                    :show-overflow-tooltip="true"
                    min-width="180">
                    <template scope="scope">
                        <div style="text-align: left;">
                            {{scope.row.secondAgentFhWay|dictname('second_agent_fh_way')}}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="prodtype"
                        label="自产/OEM"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="订单审核状态"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.status|dictname('order_status')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="statusFj"
                        label="附件审核状态"
                        v-if="false"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.statusFj|dictname('order_status')}}
                    </template>
                </el-table-column>
         <!--       <el-table-column
                        prop="firstLevelAgentCode"
                        label="一级经销商编码"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>-->
                <el-table-column
                        prop="firstLevelAgentName"
                        label="一级经销商名称"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>

                <el-table-column
                        prop="firstSapCode"
                        label="一级经销商订单号"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="firstStatus"
                        label="一级经销商订单号状态"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        {{scope.row.firstStatus|dictname('order_status')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="orderCategory"
                        label="订单类型"
                        :show-overflow-tooltip="true"
                        width="100">
                    <template scope="scope">
                        {{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="saleGroupCode"
                        label="销售组织"
                        :show-overflow-tooltip="true"
                        width="260">
                    <template scope="scope">
                        <div style="text-align: left;" v-if="scope.row.saleGroupCode != '1S00' && scope.row.saleGroupCode != '1S30'">
                            [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                        </div>

                        <div style="text-align: left;" v-if="scope.row.saleGroupCode == '1S00' && scope.row.saleGroupCode == '1S30'">
                            {{scope.row.firstLevelAgentName}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="soldToCode"
                        label="售达方编码"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>

                <el-table-column
                        prop="soldToAreaName"
                        label="售达方地区"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <!--<el-table-column-->
                        <!--prop="currencyCode"-->
                        <!--label="币种编码"-->
                        <!--width="110">-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="disChannelCode"
                        label="分销渠道编码"
                        :show-overflow-tooltip="true"
                        width="130">
                    <template scope="scope">
                        {{scope.row.disChannelCode|dictname('fenxiao_qudao')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="customerChannelCode"
                        label="客户渠道"
                        :show-overflow-tooltip="true"
                        width="90">
                    <template scope="scope">
                        {{scope.row.customerChannelCode|dictname('sales_region')}}
                    </template>
                </el-table-column>

                <el-table-column
                        prop="cuname"
                        label="创建人名称"
                        :show-overflow-tooltip="true"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        width="160">
                </el-table-column>

                <el-table-column
                        prop="toCompanyname"
                        label="收货单位"
                        :show-overflow-tooltip="true"
                        width="180">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.toCompanyname}}
                            </div>
                        </template>
                </el-table-column>
                <el-table-column
                        prop="contactName"
                        label="收货联系人"
                        width="110">
                </el-table-column>

                <!--<el-table-column-->
                        <!--prop="wldw"-->
                        <!--label="单位"-->
                        <!--width="70">-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        :show-overflow-tooltip="true"
                        :v-if="showPrice"
                        width="80">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.finalPrice}}
                                </div>
                            </template>
                </el-table-column>
                <el-table-column
                        prop="totalprice"
                        label="总价"
                        :show-overflow-tooltip="true"
                        :v-if="showPrice"
                        width="80">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.totalprice}}
                                </div>
                            </template>
                </el-table-column>
                <el-table-column
                        prop="jinejjz"
                        label="不含税总价"
                        :show-overflow-tooltip="true"
                        :v-if="showPrice"
                        width="110">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.jinejjz}}
                                </div>
                            </template>
                </el-table-column>
                <el-table-column
                        prop="totalprice"
                        label="汇算总价"
                        :show-overflow-tooltip="true"
                        :v-if="showPrice"
                        width="90">
                            <template scope="scope">
                                <div style="text-align: right;">
                                    {{scope.row.totalprice}}
                                </div>
                            </template>
                </el-table-column>
                <el-table-column
                        prop="acceptTime"
                        label="签收时间"
                        v-if="false"
                        :show-overflow-tooltip="true"
                        :formatter="formatDate"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="thawStatus"
                        label="签收状态"
                        v-if="false"
                        :show-overflow-tooltip="true"
                        width="60">
                    <template scope="scope">
                        <span v-if="scope.row.thawStatus == 'Y'">已签收</span>
                        <span v-if="scope.row.thawStatus == 'N'">未签收</span>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="260"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <div v-if="scope.row.status == '10'" style="text-align: left;">
                                <el-button
                                        v-if="_user.usercode == scope.row.cucode || adminFlag"
                                        size="small" class="h-tableLink h-btn"
                                        @click="handleEdit(scope.row)">编辑
                                </el-button>
                                <el-button
                                        v-if="_user.usercode == scope.row.cucode || adminFlag"
                                        size="small" class="h-tableLink h-btn"
                                        @click="deleteSecondOrder(scope.row)">删除
                                </el-button>
                            </div>
                            <div v-else style="text-align: left;">
                                <el-button v-if="scope.row.binstid"
                                        size="small" class="h-tableLink h-btn"
                                        @click="genzongLiuch(scope.row.binstid)">
                                    跟踪
                                </el-button>
                                <el-button v-if="scope.row.instidFj"
                                           size="small" class="h-tableLink h-btn"
                                           @click="genzongLiuch(scope.row.instidFj)">
                                    附件审批跟踪
                                </el-button>
                                <el-button v-if="scope.row.swinstid"
                                           size="small" class="h-tableLink h-btn"
                                           @click="genzongLiuch(scope.row.swinstid)">
                                    关联跟踪
                                </el-button>
                                <el-button
                                        size="small" class="h-tableLink h-btn"
                                        @click="handelDetail(scope.row)">查看
                                </el-button>


                                <el-button
                                        v-if="scope.row.status == 30"
                                        size="small" class="h-tableLink h-btn"
                                        @click="deleteSecondOrder(scope.row)">删除
                                </el-button>
                                <el-button
                                        v-if="_user.usercode == scope.row.cucode && scope.row.status == 20"
                                        size="small" class="h-tableLink h-btn"
                                        @click="sapCHOrder(scope.row)">撤回
                                </el-button>
                                <span v-if="_user.usercode == scope.row.cucode">
                                    <el-button
                                            v-if="scope.row.shenpiflag"
                                            size="small" class="h-tableLink h-btn"
                                            @click="shenpiopt(scope.row, '1')">
                                    提报
                                    </el-button>
                                </span>
                              <el-button
                                  v-if="scope.row.status > 30 && scope.row.status < 70 && 1 == _user.agentLevel
                                        && '1' == scope.row.secondAgentFhWay && '1' == scope.row.orderCategory && '100' != scope.row.status && scope.row.sapCode.indexOf('HHN') == -1"
                                  size="small" class="h-tableLink h-btn"
                                  @click="sendOutGoods(scope.row)">发货
                              </el-button>

                                <el-button
                                        v-if="(scope.row.nxThreeTime||false) && (scope.row.orderCategory == '1')"
                                        :key="Math.random()"
                                        size="small" class="h-tableLink h-btn"
                                        @click="openWuliu(scope.row.firstSapCode)">物流跟踪
                                </el-button>
                                <el-button
                                        v-if = "(isfpprint) && (scope.row.firstStatus == '60'
									|| scope.row.firstStatus == '50' ||scope.row.firstStatus == '100') "
                                        size="small" class="h-tableLink h-btn"
                                        @click="printlnFhd(scope.row.firstSapCode)">发货单打印
                                </el-button>


                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
                <div style="display:flex;align-items: center;">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                            @click="exportExcel">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ"
                               @click="importAllFj" >批量上传发票附件
                    </el-button>


                </div>
                <uploaddownexcel
                        :visible.sync="uploaddownexcelflag"
                        v-if="uploaddownexcelflag"
                        clsname="viewOrderImportExcel"
                        :startrow="3" @callback="uploadExcelFilecallback"/>
            </div>
        </div>


        <!--创建订单弹出框-->
        <dingdadd :visible.sync="imgflag3" v-if="imgflag3" @imgfalse3="imgflag3=false"/>

        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>


        <el-dialog :close-on-click-modal="false" title="撤回订单" :visible.sync="chehuidialogFormVisible">
            <el-form :model="zuofeiyy">
                <el-form-item label="撤回原因" :label-width="100">
                    <brselect category="DD_ZFYY" :v="zuofeiyy.yy"
                            v-model="zuofeiyy.yy" ></brselect>
                </el-form-item>
                <el-form-item label="备注" :label-width="100">
                    <el-input v-model="zuofeiyy.bz" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="chehui">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="order.showOrderNxSp"
                v-if="order.showOrderNxSp"
                v-on="$listeners"
                :modal-append-to-body='false'
                append-to-body
                    :close-on-click-modal="false"
                title="内销订单"
                width="90%" class="showflowDialogcls">
            <secondOrdernxsp
                    @refreshSelf="refreshSelf"
                    :orderid="order.orderid"
                    :orderinstid="order.orderinstid"
                    :ordertaskid="order.ordertaskid"
                    :hideColumn="'secondDingdmainlist'"
                    :ordertaskstatus="order.ordertaskstatus"
            />
        </el-dialog>


        <!--上传附件-->
        <el-dialog
                :visible.sync="fjFlag"
                v-if="fjFlag"
                class="h-dialog2"
        >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>分销商订单发票附件上传</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine" style="padding:20px;border-bottom: 1px dashed #ccc;">
                <h3 style="display: inline-block;">订单号:</h3>
                <h4 style="display: inline-block;margin-left: 0.1rem;line-height: 1.6;">{{ddhB}}</h4>
            </div>
            <div class="h-formLine" style="padding:20px;">
                <h3 style="display: inline-block;">订单发票附件上传</h3>
                <h6 style="color: red;display: inline-block;margin-left: 0.1rem;font-size: 0.14rem;">(发票附件审核通过后订单自动结束)</h6>
                <brupload
                        style="margin-top: 0.1rem;"
                        :refid="_.join(_.map(this.tableSelectedList,'bid'),',')"
                        reftype="SECOND_ORDER_FJ"
                        uploadflag = "ture"
                        delflag = "ture"/>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitFujian">提 交</el-button>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="dialogGoods" class="h-dialog2">
          <div class="h-dialogImg">
            <div class="h-disTable">
              <div class="h-tableCell">
                <h1>数量确认</h1>
              </div>
            </div>
          </div>
          <div class="h-formLines">
            <el-form ref="add" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
              <el-form-item prop="sendGoodsNumber" label="发货数量" class="h-elformWrap-2" label-width="100">
                <el-input v-model="add.sendGoodsNumber" @input="validateInput" style="width: 84%" placeholder="请输入发货数量"></el-input>
              </el-form-item>
            </el-form>
            <div style="display:flex;justify-content:center;margin-bottom:20px">
              <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialog">取消</el-button>
              <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">确认发货</el-button>
            </div>
          </div>
        </el-dialog>



    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        props: ["firstPageFlag"],
        components: {
            uploaddownexcel,
        },
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                //导入Excel
                uploaddownexcelflag: false,

                fjFlag: null,
                fjCode: null,
                fhStatus: null,
                refid: null,
                reftype: null,
                showFwkaipiao: null,
                isDateFlag:false,
                kaipiao: {
                    id:null,
                    acceptTime:null,
                    sapCode:null,
                },
                ddhU:'',
                ddhB:'',
                ddhK:'',
                ddhI:'',
                spform: {
                    ywid: null,
                    taskid: null,
                    optflag: null,
                    shpyj: null,
                },

                instid: null,
                showhistory: null,
                adminFlag:false,
                imgflag3: false,
                orderTypeList: [],
                orderCategory1AllList:[],
                orderCategory1List:[],
                secondAgentFhWayList:[],
                jueseFlag: false,

                tableData: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                     cuserCodeNameLike: "",
                    sdfCodeNameLike: "",
                    materialCodeNameLike:"",
                    orderCategory: "",
                    saleGroupCode: "",
                    status: "",
                    cdatebegin:null,
                    cdateend:null,
                    orderTypebz: 1,
                    shouhuoflag:null,
                    isBlood:'',
                    prodtype:null,
                    isAccept:'',
                    thawStatus:'',
                    firstSapCode:'',
                    firstLevelAgentLike:"",
                    secondAgentFhWay:'',
                    cdatebegin:null,
                },
                fujian: {
                    id:null,
                    acceptTime:null,
                    sapCode:null,
                },
                spanArr: [],
                //作废原因
                zfyydialogFormVisible:false,
                //撤回
                chehuidialogFormVisible: false,
                zuofeiyy:{
                    id:null,
                    yy:null,
                    bz:null,
                },

                tableSelectedList:[],

                order:{
                    showOrderNxSp:false,
                    showOrderWxSp:false,
                    orderid:"",
                    orderinstid:"",
                    ordertaskid:"",
                    ordertaskstatus:"",
                },
                //是否分销商（二级经销商）
                secondAgent:false,
              //控制发货数量弹框
              dialogGoods:false,
              showPrice:false,
              //发货信息
              rows:{

              },
              //发货数量输入信息
              add:{
                sendGoodsNumber:null,
              },
            }
        },

        created() {
            this.formInline.cdatebegin = '2025-01-01'
            this.query();
            this.isDate();
            if (this.$store.getters.hasRole('swyl-fuwu')) {
                this.jueseFlag = true;
            }
            this.adminFlag = this.$store.getters.hasRole('swyl_admin');

            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
            this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:'201910254L3O3bAL'});
            this.secondAgentFhWayList =  this.$store.getters.dictlist("second_agent_fh_way");


            //判断能否显示价格信息
            //如果不是内部用户 并且 agentLevel=2
            if(!this.$store.getters.hasRole('swyl_admin') && !this.$store.getters.hasRole('swyl_guanhgly_new')){
                //判断是否是分销商（二级经销商）
                this.secondAgent = true;
            }

            if(this.$store.getters.hasRole('swyl_admin')){
                this.showPrice = true;
            }
            this.getHhAgent(this._user.usercode);
            if (this.$store.getters.hasRole('update_gsyf')) {
                this.adminFlag = true;
            }
            if (this.$store.getters.hasRole('swyl_fawu')) {
                this.isShield = true;
            }
            if (this.$store.getters.hasRole('swyl_admin')
                ||this.$store.getters.hasRole('swyl_gndailishang')
                ||this.$store.getters.hasRole('swyl_dingdgly')
                ||this.$store.getters.hasRole('xtgly-new')) {
                this.isfpprint = true;
            }
            //    项目
            //     this.listPro();
        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            refreshSelf(params){
                if(params && params.close){
                    this.order.showOrderNxSp = false;
                }
                if(params && params.refresh){
                    this.query();
                }
            },
            //是不是厚宏的代理商
            getHhAgent(agentCode) {
                ss.specialController.getHhAgent(agentCode).then(rd => {
                    console.log(rd.msg, '看看有啥')
                    if(rd.msg != 0){
                        this.showPrice = true;
                    }else {
                        this.showPrice = false;
                    }
                })
            },
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },

            changeOrderCate(cate){
                if(cate){
                    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
                    console.log(cate.id);
                }else{
                    this.orderCategory1List =  [];
                }

            },
            shenpiopt(row, flag){
                console.log(333,row)
                // /dingdmain/orderNxshenpi?taskid=20200106Cqk3e32f&ywid=2020010699cc510c&instid=20200106tqw7ZYOm&taskstatus=0
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                }
                // this.$router.push({
                //     path: row.dburl,
                //     query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
                // })
                if(flag=="1"){
                    this.$router.push({
                        path: row.dburl,
                        query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag,agentLevel:2}
                    })
                    return;
                }
                this.order.orderid=row.bid;
                this.order.orderinstid=instid;
                this.order.ordertaskstatus='0';
                this.order.ordertaskid=row.taskid;
                this.order.showOrderNxSp = true;
                return;
                // let routeData = this.$router.resolve({
                //     path: row.dburl,
                //     query: {ywid: row.bid,taskid:row.taskid, instid: instid, taskstatus: '0', chongXinTiJiao: flag}
                // });
                // window.open(routeData.href, '_blank');
            },
            //批量导出
            exportExcel() {
                var strids = _.join(_.map(this.tableSelectedList,"bid"),",");
                var form = {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    cuserCodeNameLike: "",
                    sdfCodeNameLike: "",
                    materialCodeNameLike:"",
                    orderCategory: "",
                    saleGroupCode: "",
                    status: "",
                    cdatebegin:null,
                    cdateend:null,
                    orderTypebz: 1,
                    shouhuoflag:null,
                    prodtype:null,
                };
                if (strids == '') {
                    form = _.clone(this.formInline);
                }
                form.strids = strids;
                updownfile.down("/api/swyl/v1/demo/secondOrderMain/downloadExcel", form, "post");
            },

            //批量上传附件 （上传附件后区域经理审批，通过后订单改为结束）
            importAllFj() {
                if(this.ddhB == ''){
                    this.$msg.msge("请勾选以上订单!!!");
                    return false;
                }
                var flag1 = false
                this.tableSelectedList.forEach((item, index) => {
                    if(item.status != 40){
                        flag1 = true;
                        return;
                    }
                })
                if(flag1){
                    this.$msg.msge("审核通过后的正常订单才能上传提单号,请重新选择!");
                    return;
                }
                var flag2 = false
                this.tableSelectedList.forEach((item, index) => {
                    //20 审批中 40 审批通过
                    if(item.statusFj == 20 || item.statusFj == 40){
                        flag2 = true;
                        return;
                    }
                })
                if(flag2){
                    this.$msg.msge("改订单附件已审批通过或正在审核无法上传附件!");
                    return;
                }

                var flag3 = false
                this.tableSelectedList.forEach((item, index) => {
                    if(item.secondAgentFhWay == 2){
                        flag3 = true;
                        return;
                    }
                })
                if(flag3){
                    this.$msg.msge("此订单为海尔直发无需上传附件!");
                    return;
                }


                this.fjFlag = true;
             },

            submitFujian(){
                var ids = _.join(_.map(this.tableSelectedList,"bid"),",");

                ss.SecondOrderMainService.submitFujian(ids).then(rd => {
                    this.$msg.msgs(rd.msg);
                    this.query();
                    this.fjFlag = false

                });


            },
          //打开发货数量弹框
          sendOutGoods(row){
            this.rows = row;
            console.log(this.rows);
            this.add.sendGoodsNumber = this.rows.waitGoodsNumber
            this.dialogGoods = true;
          },
          //关闭发货数量弹框
          closeDialog(){
            this.add.sendGoodsNumber = null;
            this.rows = {};
            this.dialogGoods = false;
          },
          //确认发货
          commitCreate(){
            console.log(this.rows.waitGoodsNumber);
            console.log(this.add.sendGoodsNumber);
            if (null == this.add.sendGoodsNumber || '' == this.add.sendGoodsNumber){
              this.$alert('请输入发货数量', '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
              });
              return;
            }
            if (this.add.sendGoodsNumber > this.rows.waitGoodsNumber){
              this.$alert("发货数量不能大于订单待发货数量"+this.rows.waitGoodsNumber+"，请重新输入", '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
              });
              return;
            }
            if (0 == this.add.sendGoodsNumber){
              this.$alert("发货数量不能为0，请重新输入", '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
              });
              return;
            }
            ss.SecondOrderMainService.toXiaoshouSystem(this.rows,this.add.sendGoodsNumber).then(res => {
              console.log(res)
             if(res.f == true){
               this.$alert("发货成功", '提示');
               this.closeDialog();
               this.query();
             }else {
               this.$alert(res.msg, '发货失败');
             }
            });
          },
          validateInput(){
            const regex = /^\d*$/;
            if (!regex.test(event.target.value)) {
              // 如果不符合正则，则重置为之前的值或空值
              this.add.sendGoodsNumber = '';
            }
          },
          clickInstallNumber(row){
            //secondAgentFhWay : 2,海尔直发  1,库发
            console.log(row)
            this.$router.push({
              path: "/bscAfterSalesConfirm",
              query: {sapCode: '1' == row.secondAgentFhWay ? row.sapCode : row.firstSapCode}
            })
          },


            handleSelectionChange(lists){
                this.tableSelectedList = lists;
                var str = '';
                var yw = '';
                var task = '';
                for(var i=0;i<lists.length;i++){
                    str += lists[i].sapCode + ',';
                    yw += lists[i].bid + ',';
                    task += lists[i].taskid + ',';
                }
                str = str.substring(0,str.length-1);
                yw = yw.substring(0,yw.length-1);
                task = task.substring(0,task.length-1);
                this.ddhB = str;
                this.ddhI = yw;
                this.ddhK = task;
            },

            cancel(){
                this.fjFlag = false;
            },





            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].id === this.tableData[index - 1].id) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (
                    (column.property == 'firstLevelAgentCode')
                    ||
                    (column.property == 'firstLevelAgentName')
                    ||

                    (column.property == 'orderCategory')
                    ||
                    (column.property == 'soldToCode')
                    ||
                    (column.property == 'soldToName')
                    ||
                    (column.property == 'disChannelCode')
                    ||
                    (column.property == 'orderProjectName')
                    ||
                    (column.property == 'customerChannelCode')
                    ||
                    (column.property == 'soldToAreaName')
                    ||
                    (column.property == 'toCompanyname')
                    ||
                    (column.property == 'contactName')
                    ||
                    (column.property == 'cuname')
                    ||
                    (column.property == 'cdate')
                    ||
                    (
                        (column.label == '订单状态' || column.label == '操作') &&
                        (row.status == '10' )
                    )
                    ||
                    (
                        (column.label == '操作') &&
                        (row.orderCategory == '3' )
                    )
                ) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }
            },
            genzongLiuch(instid) {
                this.instid = instid;

                this.showhistory = true;
            },
            imgfalse3() {
                this.imgflag3 = true;
            },
            //查询该用户及所有子用户所有订单详情
            query() {
                ss.SecondOrderMainService.selectSecondDingdanPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },

            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },


            // 重置按钮
            resetData() {
                this.formInline.sapCode = "";
                this.formInline.cuserCodeNameLike = "";
                this.formInline.sdfCodeNameLike = "";
                this.formInline.materialCodeNameLike = "";
                this.formInline.orderCategory = "";
                this.formInline.orderCategory1 = "";
                this.formInline.saleGroupCode = "";
                this.formInline.status = "";
                this.formInline.cdatebegin = null;
                this.formInline.cdateend = null;
                this.formInline.orderTypebz = 1;
                this.formInline.shouhuoflag = null;
                this.formInline.prodtype = null;
                this.formInline.isBlood = '';
                this.formInline.thawStatus = '';
            },

            //判断当前日期是否在允许签收的时间范围之内
            isDate(){
                ss.OrderMainService.isDate().then(rd =>{
                    this.isDateFlag = rd.msg;
                })
            },


            handleEdit(row) {
                console.log(row)
                this.toEdit(row.orderCategory, row.orderCategory1, row.id);
                // this.$router.push({path: "/dingd/createOrder", query: {id:row.id}})
            },
            handelDetail(row) {
                var instid = null;

                instid = row.binstid;

                if (row.orderCategory == '1') {
                    this.order.orderid=row.bid;
                    this.order.orderinstid=instid;
                    this.order.ordertaskstatus='1';
                    this.order.showOrderNxSp = true;
                    return;
                }
            },

            //作废订单
            sapDeleteOrder(row) {
                if (row.status == '10') {
                    this.$msg.confirm("确认作废?", () => {
                        ss.OrderMainService.sapDeleteOrder(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },

            //删除订单
            deleteSecondOrder(row) {
                // if (row.status == '10' || row.status == '30' || row.status == '70') {
                if (row.status == '10' || row.status == '30') {
                    this.$msg.confirm("确认删除?", () => {
                        ss.SecondOrderMainService.deleteSecondOrder(row.bid, row.deleteReason).then(rd => {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        });
                    });
                } else {
                    this.zuofeiyy.id = row.bid
                    this.zfyydialogFormVisible = true;
                }
            },


            //撤回订单
            sapCHOrder(row) {

                    this.zuofeiyy.id = row.bid
                    this.chehuidialogFormVisible = true;
                    this.refid = row.bid;

            },
            chehui(){
                if (!this.zuofeiyy.yy) {
                    this.$msg.msge("请选择撤回原因");
                    return false;
                }
                var yybz = this.zuofeiyy.yy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy.yy)+":"+this.zuofeiyy.bz;
                this.$msg.confirm("确认撤回?", () => {
                    ss.SecondOrderMainService.sapCHOrder(this.zuofeiyy.id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.chehuidialogFormVisible = false;
                        this.zuofeiyy = {
                            id:null,
                            yy:null,
                            bz:null,
                        };
                    });
                });
            },
            toEdit(ddlx, ddzlx, id) {
                if (ddlx == '1') {
                    if (ddzlx == '9') {
                        //服务订单
                        this.$router.push({path: "/dingd/createFuwuOrder", query: {id: id,agentLevel:2}})
                        return;
                    }
                    this.$router.push({path: "/dingd/createNxOrder", query: {id: id,agentLevel:2}})
                }
            },

            DJKPStatus() {
                var ids = [];
                var form = {};
                var obj = null;
                for(var i = 0;i < this.tableSelectedList.length;i++){
                    this.tableSelectedList[i].acceptTime = this.date1;
                    var obj = this.tableSelectedList[i];
                    ids.push(obj);
                    console.log('ids', obj);
                }
                ss.OrderMainService.updateKpStatus(ids).then(rd => {
                });
            },


            handleDelete(row) {

            },
            //导出Excel
            /*downloadExcel() {

                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.pid);
                });

                this.q.ids = idlist;
                this.q.orderCategory = this.formInline.orderCategory;
                this.q.orderType = this.formInline.orderType;
                this.q.cucode = this.formInline.cucode;
                this.q.cunameLike = this.formInline.cunameLike;
                this.q.saleGroupCode = this.formInline.saleGroupCode;
                this.q.orderStatus = this.formInline.orderStatus;

                updownfile.down("/api/swyl/v1/bsc/order/getOrderExcel?ids=" + this.q.ids, this.q.ids, "get", "data");

            },*/
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            openWuliu(sapcode){
                // https://ylwl.haierbiomedical.com/siteWaybillInfo/mdlgenzongDetail?keyName=SWN0026752
                window.open("https://ylwl.haierbiomedical.com/siteWaybillInfo/mdlgenzongDetail?keyName="+sapcode,"_blank");
            },
            printlnFhd(sapcode){
                console.log(sapcode,"sapcode111122222");
                // sapcode = "SWN0189601";
                ss.OrderMainService.getFhdPrintPdf(sapcode).then(rd => {
                    if(rd.f&&rd.obj){
                        console.log(rd.obj);
                        window.open(rd.obj);
                    }
                });
            },
        },

        mounted() {

        },

    }
</script>
<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }
    .tableclslist	.h-tableLink{
        padding:0px 2px!important;
    }
</style>
<style>
  .handHover:hover{
    cursor:pointer
  }
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
        width: 20%;
    }
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
        width: 80%;
    }
</style>
